// TODO: Add other Yes No questions (called MHQ now)

const questions = [
  {
    id: 'usedServices',
    question: 'Are you currently receiving any of the following mental health services?',
    type: 'UsedServices',
  },
  {
    id: 'phq9_1',
    question: 'Little interest or pleasure in doing things.',
    type: 'PHQ9',
  },
  {
    id: 'phq9_2',
    question: 'Feeling down, depressed, or hopeless.',
    type: 'PHQ9',
  },
  {
    id: 'gad7_1',
    question: 'Feeling nervous, anxious or on edge.',
    type: 'PHQ9',
  },
  {
    id: 'gad7_2',
    question: 'Not being able to stop or control worrying.',
    type: 'PHQ9',
  },
  {
    id: 'mhq_1',
    question: 'Are you currently having or have you recently had thought of wanting to harm yourself?',
    type: 'YesNo',
  },
  {
    id: 'mhq_2',
    question: 'Do you struggle with extreme mood swings or have you ever been diagnosed with bipolar disorder?',
    type: 'YesNo',
  },
  {
    id: 'mhq_5',
    question:
      'Are you currently experiencing any distressing thoughts like believing you are being monitored, or your thoughts or being controlled or having experiences like hearing or seeing things you are not sure others can hear or see?',
    type: 'YesNo',
  },
  {
    id: 'mhq_6',
    question:
      'Are you currently experiencing symptoms of post-traumatic stress like frequent nightmares or flashbacks?',
    type: 'YesNo',
  },
]
export default questions
